import { OccConfig } from '@spartacus/core';

export const productComparatorOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        productComparator: '/products/comparator',
      } as any,
    },
  },
};
